<template>
  <div class="m3p-contact__input m3p-contact__carrier">
    <select
      class="m3p-select m3p-form__strong"
      id="experience_year"
      name="experience_year"
      v-model="selectorValue"
      @focus="event => emit('focus', event)"
      @blur="event => emit('blur', event)"
    >
      <option value disabled>選択してください</option>
      <option
        v-for="item in selectiveExperienceYearList"
        :value="item.code"
        :key="item.code"
        >{{ item.name }}</option
      >
    </select>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const emit = defineEmits(['change', 'focus', 'blur']);

const props = defineProps({
  selectiveExperienceYearList: {
    type: Array,
    required: true
  },
  experienceYear: {
    type: String,
    required: true
  }
});

const selectorValue = ref(props.experienceYear);

const changeValue = newValue => {
  emit('change', 'year', newValue);
};

const clearDefault = () => {
  if (
    !props.selectiveExperienceYearList.find(
      item => item.code === selectorValue.value
    )
  ) {
    selectorValue.value = null;
  }
};

watch(selectorValue, newValue => changeValue(newValue));

watch(
  () => props.selectiveExperienceYearList,
  () => {
    clearDefault();
  }
);

clearDefault();
</script>
